// extracted by css-extract-rspack-plugin
module.exports =  {"weight_category":"DdRJ3","details_box":"_7Ab1","normalweight":"zHVG3","overweight":"oA58t","obesity":"h_Vls","full_width":"UjC3y","details":"eBTjx","info":"Lsnw4"};